export default (group, siteId) => [
  {
    iconClass: 'left-nav-icons left-nav-icons--skp',
    title: 'MYSKP',
    to: null,
    links: [
      {
        iconClass: '',
        title: 'Home',
        to: ['home'],
        links: false,
      },
      // {
      //   iconClass: '',
      //   title: 'Clubskp',
      //   to: ['rewards'],
      //   links: false,
      // },
      // {
      //   iconClass: '',
      //   title: 'How it Works',
      //   to: ['about'],
      //   links: false,
      // },
      // {
      //   iconClass: '',
      //   title: 'News',
      //   to: ['news'],
      //   links: false,
      // },
      // {
      //   iconClass: '',
      //   title: 'Education',
      //   to: ['education'],
      //   links: false,
      // },
      {
        iconClass: '',
        title: 'Products',
        target: '_blank',
        to:
          siteId === 'ca'
            ? 'http://www.schwarzkopf-professional.ca/skp/ca/en/home/products/brands.html'
            : 'http://www.schwarzkopf-professionalusa.com/skp/us/en/home/products/brands.html',
        links: false,
      },
      // {
      //   iconClass: '',
      //   title: 'Promotions',
      //   to: ['page', { slug: 'promotions' }],
      //   links: false,
      // },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/configs/sidebar/dropdownClubskp.js